<template>
  <div class="flex items-center space-x-3">
    <a
      v-if="showSignUpButton"
      :href="loginUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
      @click="trackLoginClick"
    >
      Login
    </a>
    <button
      v-if="showSignUpButton"
      @click="scrollToPricing"
      class="px-5 py-2.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white text-sm font-semibold rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 shadow-md shadow-green-500/20 hover:shadow-lg hover:shadow-green-500/30"
    >
      Começar Agora
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { trackFacebookCustomEvent } from '../../utils/facebook-pixel'

const router = useRouter();

// Função para capturar UTMs da URL atual
const getUtmParams = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = new URLSearchParams();
  
  // Lista de parâmetros UTM comuns
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  
  // Também captura o parâmetro 'ref' se existir
  const refParam = urlParams.get('ref');
  if (refParam) {
    utmParams.set('ref', refParam);
  }

  utmKeys.forEach(key => {
    const value = urlParams.get(key);
    if (value) {
      utmParams.set(key, value);
    }
  });
  
  return utmParams.toString();
};

// Função para adicionar UTMs a uma URL
const addUtmsToUrl = (baseUrl: string): string => {
  const utmString = getUtmParams();
  if (!utmString) return baseUrl;
  
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}${utmString}`;
};

const showSignUpButton = computed(() => {
  return !['imobiliarias', 'clinicas'].includes(router.currentRoute.value.name as string);
});

const scrollToPricing = () => {
  trackFacebookCustomEvent('ClickSignUp');
  const pricingSection = document.getElementById('pricing')
  if (pricingSection) {
    pricingSection.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    })
  } else {
    router.push('/');
    setTimeout(() => {
        const element = document.getElementById('pricing');
        if (element) element.scrollIntoView({ behavior: 'smooth' })
      }, 400);
  }
}

const trackLoginClick = (event: MouseEvent) => {
  event.preventDefault();
  trackFacebookCustomEvent('ClickLogin');

  const target = event.currentTarget as HTMLAnchorElement;
  setTimeout(() => {
    window.open(target.href, '_blank');
  }, 300);
}

const loginUrl = addUtmsToUrl('https://app.autovolt.ai/login')
</script>
